import { render, staticRenderFns } from "./CustomModalHeader.vue?vue&type=template&id=17b48b99&scoped=true&"
import script from "./CustomModalHeader.vue?vue&type=script&lang=js&"
export * from "./CustomModalHeader.vue?vue&type=script&lang=js&"
import style0 from "./CustomModalHeader.vue?vue&type=style&index=0&id=17b48b99&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b48b99",
  null
  
)

export default component.exports